// extracted by css-extract-rspack-plugin
export default {"wrapper":"ContentfulBreakoutBanner-module__wrapper__LqMkn","logoWrapper":"ContentfulBreakoutBanner-module__logoWrapper__s50As"};